import React, { useEffect, useState } from 'react'
import { event } from '@utils/gtag'
import { BiCheck, BiEnvelope } from 'react-icons/bi'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import cl from 'classnames'

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import Loader from 'react-loader-spinner'

import { api } from '@services/api'

interface FormValues {
  email: string
  error: string
  success: string
}

export const Newsletter: React.FC<{ className?: string }> = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false)

  const onEventNewsletter = () => {
    event({
      action: 'Botão Confirmar Cadastro',
      category: 'Confirmar cadastro',
      label: 'Botão Confirmação de Cadastro',
      value: 0
    })
  }

  const formik = useFormik<FormValues>({
    validateOnBlur: false,
    validateOnChange: false,
    initialValues: {
      email: '',
      error: '',
      success: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email('E-mail inválido')
        .required('E-mail é obrigatório')
    }),
    async onSubmit({ email }) {
      try {
        onEventNewsletter()
        setIsLoading(true)

        await api.post('newsletter', { email })

        formik.resetForm({})
        formik.setErrors({ success: 'E-mail cadastrado com sucesso' })
      } catch (error) {
        if (
          error.response &&
          error.response.data.error === 'email_already_registered'
        ) {
          formik.setErrors({ error: 'E-mail já cadastrado.' })
        } else {
          formik.setErrors({ error: 'E-mail não cadastrado' })
        }
      } finally {
        setIsLoading(false)
        resetButtonLabelAfter()
      }
    }
  })

  const buttonAlertText =
    formik.errors.email ?? formik.errors.error ?? formik.errors.success

  const resetButtonLabelAfter = (ms = 2000) => {
    setTimeout(() => {
      formik.setErrors({})
    }, ms)
  }

  useEffect(() => {
    if (formik.errors.email) resetButtonLabelAfter()
  }, [formik.errors.email])

  return (
    <div className={className}>
      <p className="text-xs leading-5 font-bold text-v3-gray-400 mb-2 md:text-base">
        Assine nossa newsletter
      </p>

      <form
        className="w-full h-6 relative flex items-center overflow-hidden bg-white rounded-[4px] border border-solid border-[#00000026] pl-2 pr-16 md:h-10 md:rounded-lg md:pl-3 md:pr-[114px]"
        onSubmit={formik.handleSubmit}
      >
        <BiEnvelope
          size={16}
          className={'w-full max-w-[16px] fill-[#00000073] mr-2 md:mr-2.5'}
        />

        <input
          name="email"
          className="w-full text-xs placeholder-black/25 md:text-sm"
          placeholder="Digite seu e-mail"
          autoComplete="off"
          onChange={formik.handleChange}
          value={formik.values.email}
          maxLength={320}
        />

        <button
          disabled={isLoading}
          type={buttonAlertText ? 'button' : 'submit'}
          className={cl(
            'transition-all duration-300 h-full absolute right-0 flex items-center justify-center bg-[#FF9C00] text-sm font-semibold text-[#000000E0] whitespace-nowrap overflow-hidden md:text-base md:rounded-s-lg',
            buttonAlertText
              ? 'min-w-full max-w-full'
              : 'min-w-[56px] max-w-[56px] md:min-w-[106px] md:max-w-[106px]'
          )}
          {...(buttonAlertText && { onClick: () => resetButtonLabelAfter(0) })}
        >
          {isLoading ? (
            <Loader type="ThreeDots" color="#000000E0" height={28} width={20} />
          ) : buttonAlertText ? (
            <div className="w-full flex items-center justify-center">
              {formik.errors.success && (
                <BiCheck
                  size={20}
                  className="w-full max-w-fit fill-[#000000E0] mr-1 md:mr-2"
                />
              )}
              <p className="text-sm font-normal md:text-base">
                {buttonAlertText}
              </p>
            </div>
          ) : (
            'Assine'
          )}
        </button>
      </form>
    </div>
  )
}
